import { ref, computed } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import useTablePagination from '@/composables/useTablePagination'
import useFilterCounter from '@/components/Filters/useFiltersCount'

export default function useList() {
  const toast = useToast()

  store.dispatch("unit/getAll")

  const tenantOptions = computed(() => store.getters["tenant/getSelectedItems"]);
  const tenantFilter = ref(null)

  const tableColumns = [
    {
      label: 'actions.name',
      key: 'actions',
      sortable: false
    },
    {
      label: 'ai_analytics_servers.id',
      key: 'id',
      sortable: true
    },
    {
      label: 'ai_analytics_servers.uuid',
      key: 'uuid',
      sortable: true
    },
    {
      label: 'ai_analytics_servers.server_name',
      key: 'name',
      sortable: true
    },
    {
      label: 'ai_analytics_servers.service_name',
      key: 'service_name',
      sortable: true
    },
    {
      label: 'ai_analytics_servers.online',
      key: 'online',
      sortable: true
    },
    {
      label: 'ai_analytics_servers.number_of_devices',
      key: 'devices_count',
      sortable: false
    },
    {
      label: 'ai_analytics_servers.maximum_devices',
      key: 'limit',
      sortable: true
    },
    {
      label: 'ai_analytics_servers.tenant',
      key: 'tenant.name',
      sortable: true
    }
  ]

  const fetchList = (ctx, callback) => {
    store.dispatch('ai_analytics_servers/servers/getAll', {
      q: searchQuery.value,
      max: perPage.value,
       "page[n]": currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      id_tenant: tenantFilter.value
    })
      .then(response => {
        callback(response.data)
        totalList.value = response.meta ? response.meta.total : response.data.length
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error obteniendo la información',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const {
    refListTable,
    perPage,
    totalList,
    currentPage,
    searchQuery,
    sortBy,
    isSortDirDesc,
    perPageOptions,
    dataMeta,
    refetchData,
    updatePagination,
  } = useTablePagination({
    fetchCallback: fetchList,
    initialPerPage: 10,
    initialSortBy: 'id',
    initialSortDesc: false
  })

  // filters counter ============================
  const filters = ref({})
  const filtersCount = useFilterCounter(filters)
  const buildFilters = () => {
    filters.value = {
      id_tenant: tenantFilter.value,
    }
    refetchData()
  }
  const clearSearchFilters = () => {
    tenantFilter.value = null
    buildFilters()
  }
  // ============================================

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    refetchData,
    updatePagination,
    tenantOptions,
    tenantFilter,
    buildFilters,
    clearSearchFilters,
    filtersCount,
  }
}
